import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queryClient.js";
import "./index.css";
import App from "./App.jsx";

// MSAL silent token renewal loads redirectUri in a hidden iframe. Booting the
// SPA there would call acquireTokenRedirect and throw block_iframe_reload.
const inIframe = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
})();

if (!inIframe) {
  createRoot(document.getElementById("root")).render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>,
  );
}
